/**
 * Cliente HTTP sem Axios nem fetch — só XMLHttpRequest.
 * Evita completamente o erro do browser: GET/HEAD não podem ter body.
 */
import { getApiBaseUrl } from '../config/apiUrl';
import { sanitizeHttpHeaderValue } from '../utils/httpHeaders';

function joinUrl(base, path) {
  const b = String(base || '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${b}${p}`;
}

function buildUrlWithParams(baseURL, path, params) {
  let url = joinUrl(baseURL, path);
  if (params && typeof params === 'object') {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') qs.append(k, String(v));
    });
    const s = qs.toString();
    if (s) url += `${url.includes('?') ? '&' : '?'}${s}`;
  }
  return url;
}

function request(method, path, options = {}) {
  const { params, data, timeoutMs } = options;
  const baseURL = getApiBaseUrl();
  const url = buildUrlWithParams(baseURL, path, params);
  const m = method.toUpperCase();

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(m, url, true);
    if (timeoutMs != null && Number(timeoutMs) > 0) {
      xhr.timeout = Number(timeoutMs);
    }

    const token = localStorage.getItem('token');
    if (token) {
      xhr.setRequestHeader('Authorization', `Bearer ${sanitizeHttpHeaderValue(token)}`);
    }

    if (m === 'GET' || m === 'HEAD') {
      xhr.send();
    } else {
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
      xhr.send(data !== undefined ? JSON.stringify(data) : undefined);
    }

    xhr.onload = () => {
      const text = xhr.responseText || '';
      let parsed = text;
      try {
        parsed = text ? JSON.parse(text) : null;
      } catch (_) {
        parsed = text;
      }

      const payload = {
        data: parsed,
        status: xhr.status,
        statusText: xhr.statusText,
        headers: xhr.getAllResponseHeaders(),
      };

      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(payload);
      } else {
        const err = new Error(payload.statusText || `HTTP ${xhr.status}`);
        err.response = payload;
        err.isAxiosError = true;
        reject(err);
      }
    };

    xhr.onerror = () => {
      const err = new Error('Network error');
      err.isAxiosError = true;
      reject(err);
    };

    xhr.ontimeout = () => {
      const err = new Error('Tempo esgotado na ligação ao servidor');
      err.isAxiosError = true;
      err.code = 'ECONNABORTED';
      reject(err);
    };
  });
}

/** Mesma superfície usada em api.js (substitui axios). */
export const nativeApi = {
  get: (path, config) => request('GET', path, config || {}),
  post: (path, body, config) => request('POST', path, { data: body, ...(config || {}) }),
  put: (path, body) => request('PUT', path, { data: body }),
  patch: (path, body) => request('PATCH', path, { data: body }),
  delete: (path, config) => request('DELETE', path, config || {}),
};
